import React from 'react';
import { IconsPros } from './types';

/**
 * MoveUp Icon component
 *
 * @returns JSX.ELEMENT
 */
export const MoveUpIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M14,14.82c.84,0,.86,0,.86-.49V9.46H10.28v3.35H5.72V9.46H1.14v4.86c0,.47,0,.49.86.49ZM0,8.31V1.67C0,.39.68,0,2,0H14c1.33,0,2,.39,2,1.67V14.33c0,1.28-.67,1.67-2,1.67H2c-1.33,0-2-.39-2-1.67Zm6.87,0v3.32H9.14V6.78H11.2L8,3.83l-3.2,3H6.87V8.31Z" />
    </svg>
  );
};
